import { render, staticRenderFns } from "./output_amount.vue?vue&type=template&id=6e627039&"
import script from "./output_amount.vue?vue&type=script&lang=js&"
export * from "./output_amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports